export default __webpack_public_path__ + "static/kouraiScene1-cb484bede76fb3db57971045b08ac09a.mp4";